import React from 'react';

interface SimpleCheckBoxProps {
  onChange: () => void;
  selected: boolean;
  label: string;
  labelId: string;
}
const SimpleCheckBox = ({
  onChange,
  selected,
  label,
  labelId,
}: SimpleCheckBoxProps): JSX.Element => {
  return (
    <>
      <input
        id={labelId}
        type={'checkbox'}
        checked={selected}
        onChange={() => onChange()}
      />
      <label
        style={{ padding: '2px', whiteSpace: 'pre-wrap' }}
        htmlFor={labelId}
      >
        {label}
      </label>
    </>
  );
};

export default SimpleCheckBox;
